export enum RoleEnum {
  ROOT = 'root',
  ADMIN = 'admin',
  USER = 'user'
}

export enum AccessLevelEnum {
  PUBLIC = 'public',
  USER = 'user',
  ADMIN = 'admin'
}

export enum GenderEnum {
  MALE = 'male',
  FEMALE = 'female',
  DIVERSE = 'diverse',
  UNKNOWN = 'unknown'
}

export enum SortEnum {
  ASC = 'asc',
  DESC = 'desc'
}

export enum DirectionEnum {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum SortOrderEnum {
  UP = 'up',
  DOWN = 'down'
}

export enum FileStorageDriverEnum {
  FILESYSTEM = 'filesystem'
}

export enum MediaTypeEnum {
  IMAGE = 'image',
  VIDEO = 'video',
  YOUTUBE = 'youtube'
}

export enum FormModeEnum {
  CREATE = 'create',
  UPDATE = 'update'
}

export enum FieldTypeEnum {
  STRING = 'string',
  TEXT = 'text',
  INTEGER = 'integer',
  FLOAT = 'float'
}

export enum JobStatusEnum {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELED = 'canceled'
}

export enum DayOfWeekEnum {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday'
}

export enum ReadStatusEnum {
  READ = 'read',
  UNREAD = 'unread'
}

export enum NotificationScopeEnum {
  ADMINISTRATION = 'administration',
  APPLICATION = 'application'
}

export enum NotificationTypeEnum {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  SYSTEM = 'system'
}

export enum ModuleEnum {
  AUTH = 'auth',
  PROFILE = 'profile',
  LOCALES = 'locales',
  GENERAL_SETTINGS = 'general_settings',
  CONTENT_SETTINGS = 'content_settings',
  SYSTEM_SETTINGS = 'system_settings',
  ROUTE_PARAMS = 'route_params',
  BACKUPS = 'backups',
  I18N_MESSAGES = 'i18n_messages',
  GROUPS = 'groups',
  PERMISSIONS = 'permissions',
  USERS = 'users',
  ADDRESSES = 'addresses',
  CART = 'cart',
  FILES = 'files',
  CATEGORIES = 'categories',
  PROPERTIES = 'properties',
  VEHICLE_GROUPS = 'vehicle_groups',
  BRANDS = 'brands',
  MODELS = 'models',
  PRODUCTS = 'products',
  PRODUCTS_EXCEL_EXPORTS = 'products_excel_exports',
  PRODUCTS_PDF_EXPORTS = 'products_pdf_exports',
  PRODUCTS_QR_EXPORTS = 'products_qr_exports',
  PRODUCTS_EXCEL_IMPORTS = 'products_excel_imports',
  PRODUCTS_PICTURE_IMPORTS = 'products_picture_imports',
  BLOG_POSTS = 'blog_posts',
  PAGES = 'pages',
  PRODUCTION_STAGES = 'production_stages',
  EVENTS = 'events',
  PHOTO_GALLERIES = 'photo_galleries',
  SLIDES = 'slides',
  VIDEOS = 'videos',
  CATALOGUES = 'catalogues',
  CERTIFICATES = 'certificates',
  CONTACT_UNITS = 'contact_units',
  CONTACT_FORM_MESSAGES = 'contact_form_messages',
  JOB_APPLICATIONS = 'job_applications',
  ORDERS = 'orders',
  INVOICES = 'invoices',
  CURRENCIES = 'currencies',
  EXCHANGE_RATES = 'exchange_rates',
  NOTIFICATIONS = 'notifications',
  AUDIT_LOGS = 'audit_logs',
  SEARCH_LOGS = 'search_logs',
  UNKNOWN = 'unknown'
}

export enum AuditActionEnum {
  SEND = 'send',
  READ = 'read',
  LIST = 'list',
  SORT = 'sort',
  IMPORT = 'import',
  EXPORT = 'export',
  DOWNLOAD = 'download',
  CREATE = 'create',
  SHOW = 'show',
  RETRY = 'retry',
  UPDATE = 'update',
  SYNC = 'sync',
  DELETE = 'delete',
  BULK_DELETE = 'bulk_delete',
  UNKNOWN = 'unknown'
}

export enum AuditResultEnum {
  SUCCESS = 'success',
  FAILED = 'failed'
}

export enum OrderStatusEnum {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  PROCESSING = 'processing',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  REFUNDED = 'refunded'
}

export enum MimeTypes {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  WEBP = 'image/webp',
  MP4 = 'video/mp4',
  PDF = 'application/pdf',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ZIP = 'application/zip'
}
